export enum ReviewedMixpanelEvents {
    USER_LOGGED_IN = 'user_logged_in',
    DEPOSIT_STARTED = 'deposit_started',
    DEPOSIT_COMPLETED = 'deposit_completed',
    DEPOSIT_FAILED = 'deposit_failed',
    PAGE_VIEWED = 'page_viewed',
    PAGE_LANDED = 'page_landed',
    PAYOUT_CTA_CLICKED = 'payout_cta_clicked',
    // RAF (Refer & Earn) events
    RAF_LINK_COPIED = 'raf_link_copied',
    RAF_SOCIAL_SHARE_CLICKED = 'raf_social_share_clicked',
    RAF_TIME_FILTER_CHANGED = 'raf_time_filter_changed',
    RAF_TOOLTIP_OPENED = 'raf_tooltip_opened',
    RAF_TERMS_LINK_CLICKED = 'raf_terms_link_clicked',
    RAF_CTA_TRIGGERED = 'raf_cta_triggered',
    RAF_POPUP_ERROR = 'raf_popup_error',
    RAF_POPUP_VIEWED = 'raf_popup_viewed',
    // Intercom / Help Center events
    HELP_CENTER_OPENED = 'help_center_opened',
    SUBMIT_REQUEST_CLICKED = 'submit_request_clicked',
    LIVE_CHAT_CLICKED = 'live_chat_clicked',
    LIVE_CHAT_OPENED = 'live_chat_opened',
    LIVE_CHAT_CLOSED = 'live_chat_closed',
    INTERCOM_LOAD_FAILED = 'intercom_load_failed',
    WT_AI_CHAT_BUTTON_CLICKED = 'wt_ai_chat_button_clicked',
    // Registration consent events
    REG_TC_CHECKBOX_CLICKED = 'reg_tc_checkbox_clicked',
    REG_MARKETING_CHECKBOX_CLICKED = 'reg_marketing_checkbox_clicked',
    REG_HYPERLINK_CLICKED = 'reg_hyperlink_clicked',
    REG_BUTTON_CLICKED = 'reg_button_clicked',
    REG_TAC_VALIDATION_ERROR = 'reg_tac_validation_error',
    // Registration field-interaction events (PRD §7.1)
    REG_FIRST_NAME_FILLED = 'reg_first_name_filled',
    REG_LAST_NAME_FILLED = 'reg_last_name_filled',
    REG_EMAIL_FILLED = 'reg_email_filled',
    REG_EMAIL_ERROR = 'reg_email_error',
    REG_PASSWORD_FOCUSED = 'reg_password_focused',
    REG_PASSWORD_FILLED = 'reg_password_filled',
    REG_PASSWORD_ERROR = 'reg_password_error',
    REG_PHONE_CODE_SELECTED = 'reg_phone_code_selected',
    REG_PHONE_NUMBER_FILLED = 'reg_phone_number_filled',
    REG_COUNTRY_SEARCH_STARTED = 'reg_country_search_started',
    REG_COUNTRY_SELECTED = 'reg_country_selected',
    REG_COUNTRY_CHANGED = 'reg_country_changed',
    REG_COUNTRY_ERROR = 'reg_country_error',
    // Registration form-level events (PRD §7.2)
    REG_FORM_VIEWED = 'reg_form_viewed',
    REG_FORM_SUBMITTED = 'reg_form_submitted',
    REG_FORM_SUCCESS = 'reg_form_success',
    REG_FORM_ABANDONED = 'reg_form_abandoned',
    // Google registration completion page events (PRD §7.3)
    REG_GOOGLE_COMPLETION_VIEWED = 'reg_google_completion_viewed',
    REG_GOOGLE_COMPLETION_SUBMITTED = 'reg_google_completion_submitted',
    REG_GOOGLE_COMPLETION_SUCCESS = 'reg_google_completion_success',
    REG_GOOGLE_COMPLETION_ABANDONED = 'reg_google_completion_abandoned',
    REG_GOOGLE_COMPLETION_SKIPPED = 'reg_google_completion_skipped',
}
